import { motion } from 'framer-motion';
import { TRIP_TYPES } from '@/lib/index';
import type { TripType } from '@/lib/index';

interface Step1Props { tripType: TripType; onChange: (t: TripType) => void; }

export function Step1TripType({ tripType, onChange }: Step1Props) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      <div className="text-center space-y-2 mb-6">
        <h2 className="font-serif text-3xl font-bold text-foreground">What kind of trip are you dreaming of?</h2>
        <p className="text-muted-foreground text-sm">Pick the vibe that best matches your vision. This shapes the entire questionnaire.</p>
      </div>
      <div className="grid gap-4">
        {TRIP_TYPES.map((type) => (
          <motion.button key={type.id} type="button" whileHover={{ scale: 1.01 }} whileTap={{ scale: 0.98 }}
            onClick={() => onChange(type.id as TripType)}
            className={`w-full text-left p-5 rounded-2xl border-2 transition-all duration-200 ${
              tripType === type.id
                ? 'border-secondary bg-secondary/10 shadow-md'
                : 'border-border bg-card hover:border-primary/40 hover:bg-primary/5'
            }`}>
            <div className="flex items-center gap-4">
              <span className="text-3xl">{type.emoji}</span>
              <div>
                <div className="font-semibold text-foreground font-serif text-base">{type.label}</div>
                <div className="text-xs text-muted-foreground mt-0.5">{type.desc}</div>
              </div>
              {tripType === type.id && (
                <div className="ml-auto w-6 h-6 rounded-full bg-secondary flex items-center justify-center flex-shrink-0">
                  <svg className="w-3 h-3 text-secondary-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              )}
            </div>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
}
